export enum NavbarItemType {
  BUTTON,
  CHECKBOX,
  REVISIONS,
  LABEL,
}
